let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cqT0F")).then(() => parcelRequire('g8gEr'));